// extracted by mini-css-extract-plugin
export var dateLabel = "_2x-0";
export var dateLabelError = "_2x-1";
export var fullWidth = "_2x-2";
export var smaller = "_2x-3";